$shm_hitalama_map_widget_float_entity_editor $shm_hitalama_map_widget_float
	controls /
		<= Help $mol_text
			text \Текст до * и # — название поля; оно же ключ в данных формы. Внутренний ID создаётся автоматически и сохраняется при переименовании. * означает обязательное поле, # — тип.
		<= Fields $mol_textarea
			title \Схема полей
			hint \Название* #string
			sidebar_showed true
			value? <=> fields_text? \
